import React from 'react';
import { scrollToAnchor } from '../utils/defaults';

export default function JardinsMobileBookingBar({ sections, interactive, viewport }) {
  if (viewport !== 'mobile') return null;
  const hasResa = (sections || []).some(
    (s) => s.id === 'sec-j-resa' || s.kitSectionTone === 'reservation' || s.anchor === 'reservation',
  );
  if (!hasResa) return null;

  const onClick = () => {
    if (interactive) scrollToAnchor('reservation');
  };

  return (
    <div className="wc-jardins-mobile-booking" aria-hidden={viewport === 'desktop'}>
      <button type="button" className="wc-jardins-mobile-booking__btn" onClick={onClick}>
        <span>Réserver une table</span>
        <span className="jardins-arrow-ne" aria-hidden="true" />
      </button>
    </div>
  );
}
